import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import sortBy from 'lodash/sortBy';
import DropdownIcon from 'images/icons/arrow.inline.svg';
import {Collapse, mainItem, clickDropdown, arrow, docArrow, expanded, collapseContent } from './styles.module.scss';


const CollapsibleList = React.memo(function MemoCollapsibleList({ items, className = '' }){
  const [isExpanded, setIsExpanded] = useState(false)

  const toggle = () => {
    setIsExpanded(prevState => !prevState)
  }

  items = sortBy(items, 'order');

  return (
    <ul className={className}>
      {items.map((rootItem) => {
        const subItems = rootItem.subItems;
        const isExternalLink = rootItem.externalLink;

        return (
          <li className={Collapse} key={rootItem.name}>
            <div className={mainItem}>
              {!isExternalLink && rootItem.link !== '' && (
                <Link
                  to={rootItem.link ? `/${rootItem.link}` : '/'}
                  className="collapsibleLink"
                  activeClassName="active"
                >
                  {rootItem.name}
                </Link>
              )} 
              
              {!isExternalLink &&  rootItem.link === '' && (<span className={clickDropdown} role="button" tabIndex={0} aria-label="expand" onClick={toggle}>{rootItem.name}</span>)}

              {rootItem.externalLink && (
                <a href={rootItem.externalLink} target="_blank" rel="noopener noreferrer">
                  <span>{rootItem.name}</span>
                </a>
              )}

              {subItems && subItems.length > 0 && (
                <span
                  className={`${arrow} ${docArrow} ${isExpanded ? expanded : ''} ${className}`}
                  role="button"
                  tabIndex={0}
                  aria-label="expand"
                >
                  <DropdownIcon onClick={toggle}/>
                </span>
              )}
            </div>
            {((subItems && subItems.length > 0 && isExpanded &&
                <ul className={collapseContent}>
                  <CollapsibleList items={subItems} className={className}/>
                </ul>
              ))}
          </li>
        );
      })}
    </ul>
  );
})


CollapsibleList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      subItems: PropTypes.array,
    }),
  ).isRequired,
  className: PropTypes.string
};

export default CollapsibleList;
